import React, { useState } from "react";
import "./App.css";
import Home from "./Components/Home/Home";
import { UserProvider } from "./userContext";
import { BrowserRouter as Router, Switch, Route } from "react-router-dom";
import Header from "./Components/Header/Header";
import PrivateRoute from "./Components/PrivateRoute/PrivateRoute";
import Destination from "./Components/Destination/Destination";
import Login from "./Components/Login/Login";

function App() {
  const [loggedInUser, setLoggedInUser] = useState({});
  return (
    <UserProvider value={[loggedInUser, setLoggedInUser]}>
      {/* <p>Name: {loggedInUser.name}</p> */}
      <Router>
        <Header />
        <Switch>
          <Route exact path="/">
            <Home></Home>
          </Route>
          <PrivateRoute path="/destination/:id">
            <Destination></Destination>
          </PrivateRoute>
          <Route path="/login">
            <Login />
          </Route>
        </Switch>
      </Router>
    </UserProvider>
  );
}

export default App;
